<template>
  <div class="cotract" style="padding:2px;height:590px">
    <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:560px">
      <div class="title">
        电子合约
      </div>
      <div class="contract-body">
        <div style="display:flex;justify-content: left;">
          <div class="line-item">
            甲方（收货方）：
            <input
              v-model="contract_data.PartA"
              readonly
              class="subline-input"
              type="text"
            />
          </div>
          <div class="line-item" style="margin-left:30px">
            乙方（送货方）：
            <input
              v-model="contract_data.PartB"
              readonly
              class="subline-input"
              type="text"
            />
          </div>
        </div>
        <p>
          根据《中华人民共和国合同法》及其他有关法律的规定，甲乙双方在平等、自愿、公平、诚实信用的基础上，就供货的有关事宜达成如下协议。
        </p>
        <!-- <p>
          一、供货的品种名称：<input
            class="subline-input"
            type="text"
            style="width:300px"
          />。
        </p> -->
        <p>一、质量标准：符合国家食品卫生标准或国家相应的标准要求。</p>
        <p>
          二、乙方保证：依照国家相关准入条件，持有有效的食品卫生许可证、工商营业执照合法经营。所供货品按照国家有关规定索取卫生许可证、工商营业执照、同批次的有资质的检验机构出具的产品合格检验报告或定点屠宰企业出仓单和动检部门检疫合格证或农药残留检验合格证。并提供每批货品的清单或购物凭证。
        </p>
        <p>
          三、货物验收：甲方对乙方所供的每批货品应进行验收，对交付的货品不符合质量、卫生要求或来自不具备合法资质企业的，甲方有权拒收，并及时通知乙方，因质量问题严重或被相关监管部门查处，甲方有权解除合同，造成的损失，乙方应承担赔偿责任。
        </p>
        <!-- <p>五、合作方式</p>
        <p>六、付款方式</p> -->
        <p>四、合约商品：具体请参考合约商品列表</p>
        <p>
          五、合约有效期：为
          <input
            class="subline-input"
            v-model="contract_data.start_time"
            type="text"
            style="width:200px"
          />
          至<input
            class="subline-input"
            v-model="contract_data.expire_in"
            type="text"
            style="width:200px"
          />。
        </p>
        <p>六、未尽事宜，由双方共同商定。</p>
        <br />
        <br />
        <p>甲方（收货方）： <input class="subline-input" type="text" /></p>
        <p>乙方（送货方）： <input class="subline-input" type="text" /></p>
        <p>
          创&nbsp;&nbsp;建&nbsp;&nbsp;时&nbsp;&nbsp;间&nbsp;&nbsp;&nbsp;&nbsp;：&nbsp;&nbsp;<input
            v-model="contract_data.create_time"
            class="subline-input"
            type="text"
            style="width:200px"
          />
        </p>
      </div>
    </el-scrollbar>
    <div class="">
      <el-button size="small" @click="downLoadToDocx"> 下载合同正文 </el-button>
    </div>
  </div>
</template>
<script>
import { exportDocx } from "@/js/docx";
export default {
  name: "contractBD",
  data() {
    return {
      contract_data: {
        request_no:
          "CNA96683BB3C418691A9FBD46495C05BDFCE930E74A14C578A35E5F80B919553",
        contract_no: "CNBB078CE552461FB2D1147149F468E0",
        sponsor: "8478358784",
        PartA: "8122763056",
        PartB: "8478358784",
        content: "测试",
        status: "0",
        start_time: "2023/4/7 15:32:57",
        expire_in: "2099/12/30 0:00:00",
        create_id: "1442360645",
        create_time: "2023/4/7 15:40:46",
        oper_id: "1442360645",
        oper_time: "2023/4/7 15:40:46",
        other1: ""
      }
    };
  },
  methods: {
    assignment(e) {
      console.log("正文模板里的", e);
      this.contract_data = e;
    },
    downLoadToDocx() {
      let data = {
        partA: this.contract_data.PartA,
        partB: this.contract_data.PartB,
        start_time: this.contract_data.start_time,
        expire_in: this.contract_data.expire_in,
        create_time: this.contract_data.create_time
      };
      exportDocx("../../../../assets/template.docx", data, `电子合约.docx`);
      // console.log("下载电子合约");
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  height: 30px;
  font-size: 24px;
  /* background-color:blanchedalmond; */
  text-align: center;
  margin: 0 0 5px 0;
}
.subline-input {
  width: 200px;
  height: 30px;
  border: none;
  border-bottom: 1px solid #000;
  font-style: normal;
  outline: none;
  padding-left: 10px;
  font-size: 20px;
}
.line-item {
  margin: 5px 0;
}

.button-fa {
  height: 30px;
}
</style>
